import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { NitrogenModelPropertiesComponent } from './nitrogen-model-properties.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'nitrogen-model-properties',
        component: NitrogenModelPropertiesComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class NitrogenModelPropertiesRoutingModule {}
